module.exports = __webpack_public_path__ + "static/MC_YT_Thumb1-fc1a8bf508d5543236932420a96df76d.jpeg";